import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import '../../index.css';


const Layout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  const handleSidebarToggle = (expanded) => {
    setSidebarExpanded(expanded);
  };

  return (
    <div className="main-container">
      <Header />
      
      <div className="content-wrapper">
        <Sidebar 
          isExpanded={sidebarExpanded} 
          onToggle={handleSidebarToggle}
        />
        
        <main className={`main-content ${sidebarExpanded ? 'expanded' : ''}`}>
          <div className="content-scrollable">
            <div className="content-padding">
              <Outlet/>
             
            </div>
          </div>
        </main>
      </div>
      
      <Footer />
    </div>
  );
};

export default Layout;

